




































import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import AuthStore from "../../store/auth.store";

@Component
export default class ReusableForm extends Vue {
  private authStore: AuthStore = getModule(AuthStore, this.$store);
  @Prop() todayDate!: string;
  @Prop() storedStartDate!: string;
  @Prop() storedEndDate!: string;
  @Prop() storedSelectedCustomer!: string;
  private startDate = "";
  private endDate = "";
  private get customers() {
    return this.authStore.getSites;
  }

  created() {
    // assign values to class fields to avoid mutating props
    this.startDate = this.storedStartDate;
    this.endDate = this.storedEndDate;
  }

  handleDateFormSubmit(event: any) {
    this.$emit("selectionChanged", {
      startDate: this.startDate,
      endDate: this.endDate,
      site: event.target[0].value
    });
  }
}
